"use client";

import type { FC } from "react";
import { EnvelopeIcon } from "@heroicons/react/24/outline";
import type { Inquiry } from "cmw-client";
import { useDrawer } from "@/components/drawer";
import { InquiryDetail } from "../inquiry-detail";

type OpenInquiryActionProps = {
  inquiry: Inquiry;
};

/**
 * The Action cell of the enquiries table. A component rather than an inline `cell` function
 * because it needs `useDrawer` (spec §9.3 in `data-table`'s own convention — see
 * `ResendInviteAction` for the same shape).
 */
export const OpenInquiryAction: FC<OpenInquiryActionProps> = ({ inquiry }) => {
  const { openDrawer } = useDrawer();

  return (
    <button
      type="button"
      onClick={() => openDrawer(<InquiryDetail inquiry={inquiry} />, { title: "Message" })}
      className="flex cursor-pointer items-center gap-8 text-16 whitespace-nowrap text-neutral-black transition-colors hover:underline"
    >
      <EnvelopeIcon aria-hidden className="size-18 shrink-0 text-brand-blue" />
      See Message
    </button>
  );
};
